export default function Education() {
    return(
        <>
            <h2>Education</h2>
            <div className='education'>
            <div><b>John Brown University</b> | 2020 - 2024 </div>
            <div className='degree'>Bachelor of Science, Computer Science</div>
            <ul className='accomplishments'>
                <li>Received Cum Laude</li>
                <li>GPA 3.8</li>
            </ul>
            </div>
        </>
    )
}